import React from 'react'

class NotFound extends React.Component {
    render(){
        return(
            <div className="notFound">
                <div>
                    Page Not Found!
                </div>
            </div>
        )
    }
}

export default NotFound